import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import React from "react";
import { AppButton, AppOutlineButton } from "../StyledComponent";

const ConfirmDeleteDialogBox = (props) => {
  const { isConfirmOpen, handleConfirmClose, handleDeleteHoliday } = props;
  
  return (
    <Dialog
      open={isConfirmOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: "10px",
          minWidth: 400,
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">
        <Typography variant="h5" sx={{ fontWeight: 500 }}>
          Confirm Delete
        </Typography>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ py: 3 }}>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete this? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2, justifyContent: "flex-end", gap: 1 }}>
        <AppOutlineButton 
          onClick={handleConfirmClose} 
          size="small" 
          sx={{ fontSize: 15 }}
        >
          Cancel
        </AppOutlineButton>
        <AppButton
          onClick={handleDeleteHoliday}
          autoFocus
          size="small"
          variant="contained"
          color="error"
        >
          Delete
        </AppButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialogBox;
